import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion1 from '../../../../ui/images/questions/math/grade-k3/question-1.png'
import imgQuestion2 from '../../../../ui/images/questions/math/grade-k3/question-2.png'
import imgQuestion6 from '../../../../ui/images/questions/math/grade-k3/question-6.png'
import imgQuestion7 from '../../../../ui/images/questions/math/grade-k3/question-7.png'
import imgQuestion9 from '../../../../ui/images/questions/math/grade-k3/question-9.png'
import imgQuestion10 from '../../../../ui/images/questions/math/grade-k3/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k3_1',
    title: 'Find out the multiplier that results in 54.',
    topic: 'Multiplication with Units 6-9',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k3_1_a',
        text: '4',
      },
      {
        name: 'grade_k3_1_b',
        text: '5',
      },
      {
        name: 'grade_k3_1_c',
        text: '6',
        correct: true,
      },
      {
        name: 'grade_k3_1_d',
        text: '7',
      },
    ],
  },
  {
    name: 'grade_k3_2',
    title: 'Noah has 6 trays of 10 cookies. His mother baked 2 more trays. Can you guess which expression counts the total number of cookies for him?',
    topic: 'Two-Step Word Problem',
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k3_2_a',
        text: '(6 + 10) + (2 + 10)',
      },
      {
        name: 'grade_k3_2_b',
        text: '(6 × 10) + (2 × 10)',
        correct: true,
      },
      {
        name: 'grade_k3_2_c',
        text: '(6 × 10) × (2 × 10)',
      },
      {
        name: 'grade_k3_2_d',
        text: '(6 - 10) + (2 - 10)',
      },
    ],
  },
  {
    name: 'grade_k3_3',
    title: 'There are 48 students sitting in the rows in a classroom. Each row has 6 students. Which expression can find out the number of rows?',
    topic: 'Division by Whole Number',
    answers: [
      {
        name: 'grade_k3_3_a',
        text: '48 + 6 = 54',
      },
      {
        name: 'grade_k3_3_b',
        text: '48 - 6 = 42',
      },
      {
        name: 'grade_k3_3_c',
        text: '48 × 6 = 288',
      },
      {
        name: 'grade_k3_3_d',
        text: '48 ÷ 6 = 8',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_4',
    title: 'Which group of the expanded form of the number 9345 is showing the place value of each number?',
    topic: 'Place Value',
    answers: [
      {
        name: 'grade_k3_4_a',
        text: '9000 + 300 + 40 + 50',
      },
      {
        name: 'grade_k3_4_b',
        text: '900 + 300 + 40 + 5',
      },
      {
        name: 'grade_k3_4_c',
        text: '9000 + 30 + 40 + 5',
      },
      {
        name: 'grade_k3_4_d',
        text: '9000 + 300 + 40 + 5',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_5',
    title: 'Find out the INCORRECT rounding off to the nearest 100.',
    topic: 'Rounding Off to the Nearest 100.',
    answers: [
      {
        name: 'grade_k3_5_a',
        text: '110 → 200',
        correct: true,
      },
      {
        name: 'grade_k3_5_b',
        text: '6143 → 6100',
      },
      {
        name: 'grade_k3_5_c',
        text: '2655 → 2700',
      },
      {
        name: 'grade_k3_5_d',
        text: '1278 → 1300',
      },
    ],
  },
  {
    name: 'grade_k3_6',
    title: 'Follow the number line and guess the correct fraction.',
    topic: 'Fractions',
    image: imgQuestion6,
    answers: [
      {
        name: 'grade_k3_6_a',
        text: '5/9',
        correct: true,
      },
      {
        name: 'grade_k3_6_b',
        text: '1/5',
      },
      {
        name: 'grade_k3_6_c',
        text: '1/2',
      },
      {
        name: 'grade_k3_6_d',
        text: '5/5',
      },
    ],
  },
  {
    name: 'grade_k3_7',
    title: 'How many shapes are showing the fraction 5/8 of the shaded parts?',
    topic: 'Fractions',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k3_7_a',
        text: '3',
      },
      {
        name: 'grade_k3_7_b',
        text: '2',
        correct: true,
      },
      {
        name: 'grade_k3_7_c',
        text: '1',
      },
      {
        name: 'grade_k3_7_d',
        text: '4',
      },
    ],
  },
  {
    name: 'grade_k3_8',
    title: 'Which group of expressions can calculate the area and perimeter of the given rectangle?',
    topic: 'Measurement and Area',
    answers: [
      {
        name: 'grade_k3_8_a',
        text: 'Area = 6 + 3 = 9 cm² | Perimeter = 2 × (6 +3) = 18 cm',
      },
      {
        name: 'grade_k3_8_b',
        text: 'Area = 6 × 3 = 18 cm² | Perimeter = 2 × (6 +3) = 18 cm',
        correct: true,
      },
      {
        name: 'grade_k3_8_c',
        text: 'Area = 2 × (6 +3) = 18 cm | Perimeter = 6 × 3 = 18 cm²',
      },
      {
        name: 'grade_k3_8_d',
        text: 'Area = 6 × 3 = 18 cm² | Perimeter = 2 + (6 +3) = 11 cm',
      },
    ],
  },
  {
    name: 'grade_k3_9',
    title: 'Which group describes the correct coordinates of the points A, B, and C?',
    topic: 'Geometry',
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k3_9_a',
        text: 'A = 3, 5; B = 3, 3; C = -3, 3;',
      },
      {
        name: 'grade_k3_9_b',
        text: 'A = 3, 3; B = 3, 0; C = -3, 3;',
      },
      {
        name: 'grade_k3_9_c',
        text: 'A = 0, 3; B = 3, -3; C = 3, 3;',
      },
      {
        name: 'grade_k3_9_d',
        text: 'A = 3, 3; B = 3, -3; C = -3, 3;',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k3_10',
    title: 'Can you guess the correct number of ‘quadrilaterals’ in the given picture?',
    topic: 'Geometry',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k3_10_a',
        text: '4',
      },
      {
        name: 'grade_k3_10_b',
        text: '6',
        correct: true,
      },
      {
        name: 'grade_k3_10_c',
        text: '5',
      },
      {
        name: 'grade_k3_10_d',
        text: '3',
      },
    ],
  },
]
